import React from 'react';

const IconCategoryDaytime = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#fff" fillOpacity="0.5" rx="8"></rect>
      <rect
        width="31.5"
        height="31.5"
        x="0.25"
        y="0.25"
        stroke="#fff"
        strokeOpacity="0.5"
        strokeWidth="0.5"
        rx="7.75"
      ></rect>
      <path
        fill="#19191A"
        d="M10.733 14.106c3.04-.17 2.527-4.593-.47-4.064-2.368.606-1.948 4.024.47 4.064m-.282-3.262c1.587-.333 2.145 1.989.564 2.405-1.596.332-2.14-1.993-.564-2.405"
      ></path>
      <path
        fill="#19191A"
        d="M26.305 15.406v-.453c-.043-1.63-2.428-1.629-2.47 0v.411h-.824v-.412c0-.908-.739-1.647-1.647-1.647H18.22l-1.236-5.26a2.04 2.04 0 0 0-.92-1.282 2.05 2.05 0 0 0-1.555-.253L4.89 8.766c-1.083.228-1.813 1.4-1.535 2.472l2.817 12.028c.127.535.453.99.92 1.28.47.29 1.024.38 1.555.253l2.834-.664v1.523c0 1.136.923 2.06 2.058 2.06h12.353a2.06 2.06 0 0 0 2.06-2.06v-8.235c0-.994-.71-1.826-1.648-2.017m-1.647-.453c.01-.542.814-.541.824 0v.411h-.824zm-6.588-.824h3.294c.454 0 .823.37.823.824v.411h-4.94v-.412c0-.454.369-.823.823-.823m-6.588 9.16-3.024.709a1.233 1.233 0 0 1-1.484-.92l-2.817-12.03c-.165-.642.271-1.343.92-1.48l9.62-2.257c.643-.166 1.349.27 1.485.92l1.226 5.216a1.65 1.65 0 0 0-.985 1.506v.411h-1.951l-.061-.26a4.71 4.71 0 0 0 1.453-4.627l-.296-1.254a1.22 1.22 0 0 0-.549-.768c-.9-.59-2.125.285-1.855 1.329l.292 1.256a2.27 2.27 0 0 1-1.235 2.586l-1.742.84a4.735 4.735 0 0 0-2.569 5.377l.387 1.655c.074.32.27.593.549.767.888.595 2.137-.297 1.859-1.33-.165-.844-.702-2.2-.29-3.027l.781 3.335c.033.141.142.265.286.294zm0-5.866v1.43l-.485-2.067c-.062-.311-.486-.426-.698-.192a3.12 3.12 0 0 0-.787 2.876l.39 1.654a.412.412 0 0 1-.804.187l-.386-1.656a3.916 3.916 0 0 1 2.125-4.447l1.742-.84a3.09 3.09 0 0 0 1.68-3.515l-.293-1.256c-.095-.343.324-.643.618-.443a.4.4 0 0 1 .182.256l.296 1.255a3.9 3.9 0 0 1-1.367 3.966c-.243.173-.127.499-.07.733a2.066 2.066 0 0 0-2.143 2.059m15.647 8.235c0 .681-.555 1.236-1.236 1.236H13.54a1.237 1.237 0 0 1-1.235-1.236v-8.235c0-.681.554-1.235 1.235-1.235h12.353c.681 0 1.236.554 1.236 1.235z"
      ></path>
      <path
        fill="#19191A"
        d="M19.717 17.011a4.535 4.535 0 0 0-4.53 4.53c.25 6.008 8.811 6.007 9.06 0a4.535 4.535 0 0 0-4.53-4.53m0 8.236a3.71 3.71 0 0 1-3.706-3.706c.204-4.917 7.209-4.915 7.412 0a3.71 3.71 0 0 1-3.706 3.706"
      ></path>
      <path
        fill="#19191A"
        d="M19.713 18.658c-.54.01-.542.814 0 .824 1.135 0 2.059.924 2.059 2.059a.412.412 0 1 0 .823 0 2.886 2.886 0 0 0-2.882-2.883M8.643 6.481c.134.527.916.342.804-.185l-.393-1.699c-.131-.523-.915-.344-.802.186zm2.23.082c.19.12.447.064.568-.13l.653-1.046a.412.412 0 1 0-.698-.436l-.653 1.045a.41.41 0 0 0 .13.567m-5.008.262 1.046.653c.461.279.891-.403.436-.698l-1.045-.654c-.464-.279-.89.405-.437.699"
      ></path>
    </svg>
  );
};

export default IconCategoryDaytime;
